// reviews-app.jsx — 100X Equine Reviews. Loox-style media wall (photos/videos float
// to top) + text reviews stacked below, a lightbox that reuses each tile's slot id
// (same image, no double upload), and a dev-only display-options panel.
//
// DATA IS PULLED FROM THE LIVE LOOX FEED (loox.io/s/NJZoL50zcd, 2026-07-23).
// Each media review's `photo` is the real Loox CDN image, wired as the <image-slot>
// `src` so it shows immediately; a user drop overrides it and persists. To localize,
// download the CDN images into assets/ and swap the URLs. TODO(loox): feed via API.
(function () {
  const {
    useState,
    useMemo,
    useEffect,
    useCallback
  } = React;
  const PRODUCTS = {
    GUTX: {
      name: 'Gut X',
      href: '/products/gutx'
    },
    OSTEO: {
      name: 'Osteo-MAX',
      href: '/products/osteomax'
    },
    JOINT: {
      name: 'Joint Flex',
      href: '/products/jointflexplus'
    },
    JOINTCANINE: {
      name: 'Joint Flex Canine',
      href: '/products/caninejointflex'
    },
    AMINO: {
      name: 'Amino-MAX',
      href: '/products/aminomax'
    },
    HYDRA: {
      name: 'Hydra-MAX',
      href: '/products/hydramax'
    },
    CALM: {
      name: 'Max Calm',
      href: '/products/maxcalm'
    }
  };
  const CDN = 'https://images.loox.io/uploads/';

  // media: 'image' | 'video' → shows in the wall (slotId = <image-slot> key, photo = src).
  // no media → stacked in the written-reviews grid. loc is blank (Loox feed has no location).
  const REVIEWS = [{
    id: 'm1',
    slotId: 'rv-lindsay-f',
    media: 'image',
    aspect: 'port',
    photo: CDN + '2021/10/15/VyzNNTWSi.jpg',
    products: ['GUTX'],
    rating: 5,
    date: '10/15/2021',
    name: 'Lindsay F.',
    loc: '',
    helpful: 214,
    recommend: true,
    since: '2019',
    title: 'Completely off omeprazole',
    body: 'I have a middle-aged rodeo mare who internalizes everything, and I was at the point where only omeprazole would keep her quiet and happy. A fellow competitor recommended Gut X. She is eating, holding weight, traveling well, and completely off the omeprazole on gut support alone. I can’t believe it took me so long to try it, and she will never be without it again.'
  }, {
    id: 'm2',
    slotId: 'rv-jennifer-k',
    media: 'image',
    aspect: 'sq',
    photo: CDN + '2023/10/24/wSTaKGAvK.jpg',
    products: ['OSTEO'],
    rating: 5,
    date: '10/24/2023',
    name: 'Jennifer K.',
    loc: '',
    helpful: 156,
    recommend: true,
    since: '2020',
    title: 'Her coat and movement are fantastic',
    body: 'We put our OTTB on this a few months ago and her coat, body weight, and movement are fantastic on this product. We have our 21 and 23 year old quarter horses on it as well and it has made a huge difference in them too. Love this product!'
  }, {
    id: 'm3',
    slotId: 'rv-kendyl-c',
    media: 'image',
    aspect: 'land',
    photo: CDN + '2023/9/14/h-JQMr0lT.jpg',
    products: ['OSTEO'],
    rating: 5,
    date: '9/14/2023',
    name: 'Kendyl C.',
    loc: '',
    helpful: 143,
    recommend: true,
    since: '2021',
    title: 'Both barrel horses move more freely',
    body: 'I started both my barrel horses, Slick and Divinchi, and both have started to move more freely on this product. They are ten times more comfortable than before. I recommend 100X Equine to anyone considering the purchase. It is worth every penny spent.'
  }, {
    id: 'm4',
    slotId: 'rv-diana-j',
    media: 'video',
    aspect: 'land',
    photo: CDN + '2023/7/28/RswQdyQkQ.jpg',
    products: ['OSTEO'],
    rating: 5,
    date: '7/28/2023',
    name: 'Diana J.',
    loc: '',
    helpful: 189,
    recommend: true,
    since: '2022',
    title: 'Back on the trails at 25',
    body: 'My mare is a 25 year old Tennessee Walking Horse and I had only been able to ride two or three days a month. Three weeks after starting Aurora on Osteo-MAX we started trail riding again. She must feel better, the owner of our boarding facility calls her Spunky Monkey. Thank you for giving me my horse back.'
  }, {
    id: 'm5',
    slotId: 'rv-crystal-k',
    media: 'image',
    aspect: 'sq',
    photo: CDN + '2023/8/3/kVvXolcV0.jpg',
    products: ['GUTX'],
    rating: 5,
    date: '8/3/2023',
    name: 'Crystal K.',
    loc: '',
    helpful: 121,
    recommend: true,
    since: '2021',
    title: 'Happy, less spooky, willing to work',
    body: 'My mare was moody, spooky, just angry. Then I started her on Gut X and wow, what a difference. She is happy, less spooky, doesn’t fidget all the time, very attentive and just willing to work. I also can’t say enough about the customer service. Amazing people and so very helpful.'
  }, {
    id: 'm6',
    slotId: 'rv-heather-m',
    media: 'image',
    aspect: 'port',
    photo: CDN + '2023/11/28/13MyL5RB5.jpg',
    extra: 2,
    products: ['GUTX'],
    rating: 5,
    date: '11/28/2023',
    name: 'Heather M.',
    loc: '',
    helpful: 98,
    recommend: true,
    since: '2020',
    title: 'Gained all his weight back in a month',
    body: 'This is Dasher, a retired barrel horse, 25 years old. He lost weight in August, largely due to the heat of summer. I started him on Gut X and was amazed to find he gained all his weight back within a month. He is so shiny, his coat is so soft. I love this product.'
  }, {
    id: 'm7',
    slotId: 'rv-kelly-d',
    media: 'image',
    aspect: 'sq',
    photo: CDN + '2023/10/18/2KIM37NAU.jpg',
    extra: 4,
    products: ['OSTEO', 'GUTX'],
    rating: 5,
    date: '10/18/2023',
    name: 'Kelly D.',
    loc: '',
    helpful: 110,
    recommend: true,
    since: '2019',
    title: 'Back on the pattern, no limp',
    body: 'Raggedy sustained an injury to her left front knee and coronet band in training in 2022, and the vet was unsure of a performance-sound recovery. Now she is back to riding and started back on the pattern, and she loves cows and trails too. She is shiny with amazing muscle tone and no limp. I will be a lifer and true believer in all your products.'
  }, {
    id: 'm8',
    slotId: 'rv-lacey-h',
    media: 'image',
    aspect: 'port',
    photo: CDN + '2022/7/25/NygYpcv2n.jpg',
    products: ['GUTX', 'JOINT'],
    rating: 5,
    date: '7/25/2022',
    name: 'Lacey H.',
    loc: '',
    helpful: 87,
    recommend: true,
    since: '2020',
    title: 'New life for my son’s old cribber',
    body: 'These products have given my son’s old horse new life. He is in his mid-20s and a cribber. Not only has the Gut X almost stopped the cribbing completely, after two weeks on the Joint Flex he is running around the pasture again. To see him look and act like he feels great makes my heart so happy.'
  }, {
    id: 'm9',
    slotId: 'rv-jessica-c',
    media: 'image',
    aspect: 'sq',
    photo: CDN + '2023/10/24/eMKWDXwGJ.jpg',
    products: ['OSTEO'],
    rating: 5,
    date: '10/24/2023',
    name: 'Jessica C.',
    loc: '',
    helpful: 132,
    recommend: true,
    since: '2022',
    title: 'Soundest she’s been in 14 years',
    body: 'My 20 year old mare has navicular. Since using this product she has been the soundest she’s been in the last 14 years. This weekend we went on a trail ride and she was feeling too good.'
  }, {
    id: 'm10',
    slotId: 'rv-carolyn-m',
    media: 'image',
    aspect: 'land',
    photo: CDN + '2023/4/21/XYnpShqHe.jpg',
    products: ['JOINT'],
    rating: 5,
    date: '4/21/2023',
    name: 'Carolyn M.',
    loc: '',
    helpful: 176,
    recommend: true,
    since: '2021',
    title: 'At 31, still the boss of the herd',
    body: 'This supplement is amazing. My 31 year old mare has been on it for a year. Last April I was looking at putting her down. This April that thought could not be further from my mind. She is sound in all three gaits, leads on the trails, and still runs the herd like the boss she has always been.'
  }, {
    id: 'm11',
    slotId: 'rv-stacey-s',
    media: 'image',
    aspect: 'port',
    photo: CDN + '2022/10/14/E1-SePwzXp.jpg',
    products: ['OSTEO'],
    rating: 5,
    date: '10/14/2022',
    name: 'Stacey S.',
    loc: '',
    helpful: 94,
    recommend: true,
    since: '2021',
    title: 'From the slaughter yards to running again',
    body: 'Glory came to me a few years ago from the slaughter yards, and a year and a half ago she was diagnosed with severe navicular disease. She has been on Osteo-MAX for a month now and I see a huge difference. We are riding, she is running, and she just looks happier. This product is amazing.'
  }, {
    id: 'm12',
    slotId: 'rv-laura-v',
    media: 'image',
    aspect: 'sq',
    photo: CDN + '2023/10/17/TOr9vIEXV.jpg',
    extra: 3,
    products: ['GUTX'],
    rating: 5,
    date: '10/17/2023',
    name: 'Laura V.',
    loc: '',
    helpful: 168,
    recommend: true,
    since: '2018',
    title: 'Angry dragons to the sweetest souls',
    body: 'I’m a saddle fitter, barn owner, breeder, rider, trainer, and rescue president. I discovered it seeing the results first-hand in saddle fitting: horses that had been chronically girthy and reactive were no more. I’ve seen rescues and off-the-track Thoroughbreds go from angry dragons to the sweetest souls. I recommend it often and clients always thank me later.'
  }, {
    id: 'm13',
    slotId: 'rv-madeleine-h',
    media: 'image',
    aspect: 'sq',
    photo: CDN + '2023/8/9/8qufR0IpG.jpg',
    products: ['JOINTCANINE'],
    rating: 5,
    date: '8/9/2023',
    name: 'Madeleine H.',
    loc: '',
    helpful: 61,
    recommend: true,
    since: '2022',
    title: 'Exactly what we wanted for our Pyr',
    body: 'Our big Pyrenees, Gus, is doing great on this product. We are concerned about his joints and this product is exactly what we were looking for. He is only 2, but we want to give him all the joint support he can get.'
  }, {
    id: 'm14',
    slotId: 'rv-alexi-b',
    media: 'image',
    aspect: 'port',
    photo: CDN + '2023/10/20/L0VwLSDhK.jpg',
    extra: 1,
    products: ['GUTX'],
    rating: 5,
    date: '10/20/2023',
    name: 'Alexi B.',
    loc: '',
    helpful: 128,
    recommend: true,
    since: '2023',
    title: 'No more colic episodes',
    body: 'My 6 year old QH had been suffering with ulcers and chronic colic for months. We started Gut X and she is looking and feeling better than ever. She has gained weight and her coat looks healthier, but the best part is she hasn’t had any more episodes of colic. We will be lifelong customers.'
  }, {
    id: 'm15',
    slotId: 'rv-taylor-w',
    media: 'image',
    aspect: 'sq',
    photo: CDN + '2023/11/8/Kedr59JFE.jpg',
    extra: 1,
    products: ['GUTX'],
    rating: 5,
    date: '11/8/2023',
    name: 'Taylor W.',
    loc: '',
    helpful: 72,
    recommend: true,
    since: '2022',
    title: 'A year in on my two seniors',
    body: 'I’ve had my two senior horses on Gut X for a year now and the results have been amazing. I can really tell a difference in their overall health. I am definitely keeping them on Gut X forever.'
  }, {
    id: 'm16',
    slotId: 'rv-cara-k',
    media: 'image',
    aspect: 'land',
    photo: CDN + '2022/7/13/EJo62-wjn.jpg',
    products: ['OSTEO', 'GUTX'],
    rating: 5,
    date: '7/13/2022',
    name: 'Cara K.',
    loc: '',
    helpful: 103,
    recommend: true,
    since: '2021',
    title: 'Dead lame to running in two months',
    body: 'Two months ago my mare was dead lame due to laminitis at eight years old. She is now running, playing, and back to her old self, almost 100% sound. Highly recommend the Osteo-MAX and Gut X combo.'
  },
  // Written reviews (no photo) — real Loox reviews shown text-only underneath
  {
    id: 't1',
    products: ['GUTX'],
    rating: 5,
    date: '9/9/2023',
    name: 'Linda S.',
    loc: '',
    helpful: 66,
    recommend: true,
    since: '2021',
    title: 'Put the whole herd on it',
    body: 'I started Gut X two years ago. It worked so well for one of my horses, who was cinchy and watchy, most likely from ulcers, that I decided to put the rest of the herd on it. It improves their disposition and there are no more ulcer concerns. Thanks Gut X for happy horses.'
  }, {
    id: 't2',
    products: ['GUTX'],
    rating: 5,
    date: '11/10/2023',
    name: 'Heather W.',
    loc: '',
    helpful: 41,
    recommend: true,
    since: '2023',
    title: 'Ideal weight and a calmer mind',
    body: 'I got Cam six months ago. He needed a soft place to land, was a bit underweight, very nervous, and had some lordosis. I started him on Gut X along with extra grass forage. He is now at an ideal weight, and Gut X definitely helps quell his nervous side. I will continue to give it to him indefinitely.'
  }, {
    id: 't3',
    products: ['OSTEO'],
    rating: 5,
    date: '11/3/2023',
    name: 'Judy F.',
    loc: '',
    helpful: 38,
    recommend: true,
    since: '2020',
    title: 'Riding longer, the wobble is gone',
    body: 'Our two Tennessee Walkers, ages 21 and 23, seem to be doing a lot better since we started them on Osteo-MAX. We are able to ride a lot longer. Also, my mare had a slight wobble in her hindquarters and that has improved immensely. Thank you for this product.'
  }, {
    id: 't4',
    products: ['OSTEO'],
    rating: 5,
    date: '11/10/2023',
    name: 'Cassandra H.',
    loc: '',
    helpful: 52,
    recommend: true,
    since: '2019',
    title: 'Saved my show pony from retirement',
    body: 'Osteo-MAX saved my old show pony from retirement. I ran out once with poor timing in delivery and she was so sour to riding I had to wait for the next gallon. I started my young horse on it too as a preventative as she starts being conditioned for show season.'
  }, {
    id: 't5',
    products: ['GUTX'],
    rating: 5,
    date: '11/8/2023',
    name: 'Chelsey G.',
    loc: '',
    helpful: 34,
    recommend: true,
    since: '2022',
    title: 'No more girthy, shiny coat',
    body: 'I love 100X products. I noticed my guy was getting really girthy when tacking up, and he was moody in his stall. I started him on Gut X and have noticed a big difference. Gut X also really helps his coat look shiny and healthy. Great product!'
  }, {
    id: 't6',
    products: ['OSTEO', 'GUTX'],
    rating: 5,
    date: '11/23/2023',
    name: 'Amanda C.',
    loc: '',
    helpful: 29,
    recommend: true,
    since: '2023',
    title: 'A happier attitude on my Bay mare',
    body: 'Gut X has definitely improved a number of things with my Bay mare, including her attitude. She seems a bit happier and not so moody. We also started her on Osteo-MAX. Highly recommend.'
  }, {
    id: 't7',
    products: ['GUTX'],
    rating: 5,
    date: '11/9/2023',
    name: 'Madasyn H.',
    loc: '',
    helpful: 27,
    recommend: true,
    since: '2023',
    title: 'Cleared up in a few days',
    body: 'One of our training horses has made huge improvements on Gut X. She’d had loose manure for weeks. We put her on Gut X and it cleared up in just a few days.'
  }, {
    id: 't8',
    products: ['OSTEO', 'GUTX'],
    rating: 5,
    date: '11/30/2023',
    name: 'Karen S.',
    loc: '',
    helpful: 31,
    recommend: true,
    since: '2020',
    title: 'My horses in training avoid the usual issues',
    body: 'I have all my horses in training on Gut X and Osteo-MAX, and they have avoided the typical issues that so many get. I really believe your products are the reason. Thank you!'
  }, {
    id: 't9',
    products: ['OSTEO', 'GUTX'],
    rating: 5,
    date: '11/20/2023',
    name: 'Diana S.',
    loc: '',
    helpful: 44,
    recommend: true,
    since: '2021',
    title: 'Solid manure for my big Clyde',
    body: 'I ran out and figured the horses would be ok. Well, my little guy wasn’t moving so well, so now I’m on auto-ship. Our Clydesdale tried all kinds of meds through our vet and kept having cow patties. I now give all three boys Gut X. It’s a blessing to have solid poos for this big guy.'
  }, {
    id: 't10',
    products: ['GUTX'],
    rating: 5,
    date: '11/28/2023',
    name: 'Jessica P.',
    loc: '',
    helpful: 25,
    recommend: true,
    since: '2022',
    title: 'Almost every horse in my barn is on it',
    body: 'Love this product! I have all of my personal horses on it and almost every horse in my barn is on it too, and we all see a positive difference.'
  }];

  // Masonry: column count by viewport, and a greedy shortest-column packer that keeps
  // existing cards put when more load in (so "View more" appends cleanly at the bottom).
  function getCols() {
    const w = window.innerWidth;
    return w <= 700 ? 1 : w <= 1100 ? 3 : 4;
  }
  function distribute(cards, n) {
    const cols = Array.from({
      length: n
    }, () => []);
    const h = new Array(n).fill(0);
    const est = r => (r.aspect === 'port' ? 1.25 : r.aspect === 'land' ? 0.67 : 1.0) + 0.42 + Math.min(1.0, (r.body ? r.body.length : 0) / 420);
    cards.forEach(r => {
      let m = 0;
      for (let i = 1; i < n; i++) if (h[i] < h[m]) m = i;
      cols[m].push(r);
      h[m] += est(r);
    });
    return cols;
  }

  // A review's photo gallery: primary (r.photo) + any extra Loox photos (r.extra).
  // The public feed only exposed the first image URL per review; extra slots are
  // fillable and would be populated from the Loox API. Order is preserved (primary
  // first, extras follow), which matters for before/after pairs.
  // TODO(loox API): fetch the full per-review image set (before/after included) in order.
  function galleryOf(r) {
    const list = [{
      id: r.slotId,
      src: r.photo
    }];
    for (let i = 0; i < (r.extra || 0); i++) list.push({
      id: r.slotId + '-x' + i,
      src: undefined
    });
    return list;
  }
  function Stars({
    n,
    cls
  }) {
    n = n || 5;
    return /*#__PURE__*/React.createElement("span", {
      className: 'rv-stars' + (cls ? ' ' + cls : ''),
      role: "img",
      "aria-label": n + ' out of 5 stars'
    }, [0, 1, 2, 3, 4].map(i => /*#__PURE__*/React.createElement("span", {
      key: i,
      className: i < n ? 'on' : 'off'
    }, '\u2605')));
  }
  const Check = props => /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ...props
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
  function ProductTags({
    keys
  }) {
    return /*#__PURE__*/React.createElement("span", {
      className: "rv-tags"
    }, keys.map(k => /*#__PURE__*/React.createElement("a", {
      key: k,
      className: "rv-tag",
      href: PRODUCTS[k].href
    }, PRODUCTS[k].name)));
  }
  function MediaCard({
    r,
    onOpen
  }) {
    return /*#__PURE__*/React.createElement("article", {
      className: "rv-mcard"
    }, /*#__PURE__*/React.createElement("button", {
      className: 'rv-mcard-photo a-' + (r.aspect || 'sq'),
      onClick: () => onOpen(r),
      "aria-label": 'Read ' + r.name + '\u2019s review'
    }, /*#__PURE__*/React.createElement("image-slot", {
      id: r.slotId,
      src: r.photo,
      shape: "rounded",
      radius: "0",
      fit: "cover",
      placeholder: r.media === 'video' ? 'Drop video still' : 'Drop customer photo'
    }), /*#__PURE__*/React.createElement("span", {
      className: "rv-mcard-badges"
    }, r.media === 'video' && /*#__PURE__*/React.createElement("span", {
      className: "rv-tile-play"
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      fill: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M8 5v14l11-7z"
    }))), r.extra > 0 && /*#__PURE__*/React.createElement("span", {
      className: "rv-tile-more"
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "11",
      height: "11",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "3",
      y: "3",
      width: "13",
      height: "13",
      rx: "2"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 21h11a2 2 0 0 0 2-2V8"
    })), "+", r.extra))), /*#__PURE__*/React.createElement("div", {
      className: "rv-mcard-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-mcard-top"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rv-mcard-name"
    }, r.name), /*#__PURE__*/React.createElement("span", {
      className: "rv-mcard-date"
    }, r.date)), /*#__PURE__*/React.createElement(Stars, {
      n: r.rating
    }), /*#__PURE__*/React.createElement("p", {
      className: "rv-mcard-text"
    }, r.body), /*#__PURE__*/React.createElement("button", {
      className: "rv-mcard-more",
      onClick: () => onOpen(r)
    }, "Read more"), /*#__PURE__*/React.createElement("div", {
      className: "rv-mcard-foot"
    }, /*#__PURE__*/React.createElement(ProductTags, {
      keys: r.products
    }), /*#__PURE__*/React.createElement("span", {
      className: "rv-verified"
    }, /*#__PURE__*/React.createElement(Check, null), " Verified buyer"), r.since && /*#__PURE__*/React.createElement("span", {
      className: "rv-since"
    }, "Customer since ", r.since))));
  }
  function Card({
    r,
    feat
  }) {
    return /*#__PURE__*/React.createElement("article", {
      className: "rv-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-card-head"
    }, /*#__PURE__*/React.createElement(Stars, {
      n: r.rating
    }), feat.recommend && r.recommend && /*#__PURE__*/React.createElement("span", {
      className: "rv-rec"
    }, /*#__PURE__*/React.createElement(Check, null), " Would recommend")), /*#__PURE__*/React.createElement("h3", {
      className: "rv-card-ttl"
    }, r.title), /*#__PURE__*/React.createElement("p", {
      className: "rv-card-body"
    }, r.body), /*#__PURE__*/React.createElement("div", {
      className: "rv-card-foot"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-who"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rv-name"
    }, r.name), feat.location && r.loc && /*#__PURE__*/React.createElement("span", {
      className: "rv-loc"
    }, r.loc)), /*#__PURE__*/React.createElement("div", {
      className: "rv-metaline"
    }, feat.product && /*#__PURE__*/React.createElement(ProductTags, {
      keys: r.products
    }), feat.verified && /*#__PURE__*/React.createElement("span", {
      className: "rv-verified"
    }, /*#__PURE__*/React.createElement(Check, null), " Verified buyer"), r.since && /*#__PURE__*/React.createElement("span", {
      className: "rv-since"
    }, "Customer since ", r.since), feat.date && /*#__PURE__*/React.createElement("span", {
      className: "rv-date"
    }, r.date), feat.helpful && /*#__PURE__*/React.createElement("span", {
      className: "rv-helpful"
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      fill: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M12 4l8 10H4z"
    })), r.helpful))));
  }
  function Lightbox({
    r,
    onClose,
    onPrev,
    onNext
  }) {
    const [active, setActive] = useState(0);
    useEffect(() => {
      setActive(0);
    }, [r.id]);
    const gallery = galleryOf(r);
    const cur = gallery[Math.min(active, gallery.length - 1)] || gallery[0];
    useEffect(() => {
      document.body.classList.add('rv-lb-open');
      const onKey = e => {
        if (e.key === 'Escape') onClose();
        if (e.key === 'ArrowLeft') onPrev();
        if (e.key === 'ArrowRight') onNext();
      };
      document.addEventListener('keydown', onKey);
      return () => {
        document.body.classList.remove('rv-lb-open');
        document.removeEventListener('keydown', onKey);
      };
    }, [onClose, onPrev, onNext]);
    return /*#__PURE__*/React.createElement("div", {
      className: "rv-lb",
      onClick: e => {
        if (e.target === e.currentTarget) onClose();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-lb-card",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": r.name + '\u2019s review'
    }, /*#__PURE__*/React.createElement("button", {
      className: "rv-lb-close",
      "aria-label": "Close",
      onClick: onClose
    }, '\u00d7'), /*#__PURE__*/React.createElement("button", {
      className: "rv-lb-nav prev",
      "aria-label": "Previous",
      onClick: onPrev
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("polyline", {
      points: "15 18 9 12 15 6"
    }))), /*#__PURE__*/React.createElement("button", {
      className: "rv-lb-nav next",
      "aria-label": "Next",
      onClick: onNext
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("polyline", {
      points: "9 18 15 12 9 6"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "rv-lb-media"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-lb-main"
    }, r.media === 'video' && active === 0 && /*#__PURE__*/React.createElement("span", {
      className: "rv-lb-videochip"
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 24 24",
      fill: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M8 5v14l11-7z"
    })), " Video review"), /*#__PURE__*/React.createElement("image-slot", {
      id: cur.id,
      src: cur.src,
      shape: "rect",
      fit: "contain",
      placeholder: cur.src ? '' : 'Loox photo'
    })), gallery.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: "rv-lb-thumbs"
    }, gallery.map((g, i) => /*#__PURE__*/React.createElement("button", {
      key: g.id,
      className: 'rv-lb-thumb' + (i === active ? ' active' : ''),
      onClick: () => setActive(i),
      "aria-label": 'Photo ' + (i + 1) + ' of ' + gallery.length
    }, /*#__PURE__*/React.createElement("image-slot", {
      id: g.id,
      src: g.src,
      shape: "rounded",
      radius: "6",
      fit: "cover",
      placeholder: ""
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "rv-lb-body"
    }, /*#__PURE__*/React.createElement(Stars, {
      n: r.rating
    }), /*#__PURE__*/React.createElement("h3", {
      className: "rv-lb-ttl"
    }, r.title), /*#__PURE__*/React.createElement("p", {
      className: "rv-lb-text"
    }, r.body), /*#__PURE__*/React.createElement("div", {
      className: "rv-lb-foot"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-who"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rv-name"
    }, r.name), r.loc && /*#__PURE__*/React.createElement("span", {
      className: "rv-loc"
    }, r.loc)), /*#__PURE__*/React.createElement("div", {
      className: "rv-metaline"
    }, /*#__PURE__*/React.createElement(ProductTags, {
      keys: r.products
    }), /*#__PURE__*/React.createElement("span", {
      className: "rv-verified"
    }, /*#__PURE__*/React.createElement(Check, null), " Verified buyer"), /*#__PURE__*/React.createElement("span", {
      className: "rv-date"
    }, r.date))))));
  }
  const FILTERS = ['GUTX', 'OSTEO', 'JOINT', 'AMINO', 'HYDRA', 'CALM'];
  function App() {
    const text = 'grid';
    const feat = {
      verified: true,
      product: true,
      location: false,
      date: true,
      helpful: false,
      recommend: false
    };
    const [cols, setCols] = useState(getCols());
    const [filter, setFilter] = useState('ALL');
    const [lbId, setLbId] = useState(null);
    const [limit, setLimit] = useState(6);
    const [wallLimit, setWallLimit] = useState(6);
    useEffect(() => {
      const on = () => setCols(getCols());
      window.addEventListener('resize', on);
      return () => window.removeEventListener('resize', on);
    }, []);
    const pickFilter = f => {
      setFilter(f);
      setLimit(6);
      setWallLimit(6);
    };
    const inFilter = r => filter === 'ALL' || r.products.includes(filter);
    const media = useMemo(() => REVIEWS.filter(r => r.media && inFilter(r)), [filter]);
    const written = useMemo(() => REVIEWS.filter(r => !r.media && inFilter(r)), [filter]);
    const shown = written.slice(0, limit);
    const shownMedia = media.slice(0, wallLimit);
    const lbIndex = lbId == null ? -1 : media.findIndex(r => r.id === lbId);
    const openLb = useCallback(r => setLbId(r.id), []);
    const closeLb = useCallback(() => setLbId(null), []);
    const step = useCallback(d => setLbId(id => {
      const i = media.findIndex(r => r.id === id);
      if (i < 0) return id;
      return media[(i + d + media.length) % media.length].id;
    }), [media]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "rv-filterbar",
      "data-screen-label": "Product filter"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-wrap-wide"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-filter"
    }, /*#__PURE__*/React.createElement("button", {
      className: filter === 'ALL' ? 'on' : '',
      onClick: () => pickFilter('ALL')
    }, "All products"), FILTERS.map(k => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: filter === k ? 'on' : '',
      onClick: () => pickFilter(k)
    }, PRODUCTS[k].name))))), /*#__PURE__*/React.createElement("section", {
      className: "gx-section",
      "data-screen-label": "Photo wall"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-wrap-wide"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-sect-head"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-eyebrow"
    }, /*#__PURE__*/React.createElement("span", {
      className: "dot"
    }), "Straight from the barn"), /*#__PURE__*/React.createElement("h2", null, "Photos & videos from customers"), /*#__PURE__*/React.createElement("p", null, "The most recent photos and video reviews go up here as owners send them in, with thousands more across the herd.")), /*#__PURE__*/React.createElement("div", {
      className: "rv-wall"
    }, distribute(shownMedia, cols).map((col, ci) => /*#__PURE__*/React.createElement("div", {
      className: "rv-wall-col",
      key: ci
    }, col.map(r => /*#__PURE__*/React.createElement(MediaCard, {
      key: r.id,
      r: r,
      onOpen: openLb
    }))))), media.length === 0 && /*#__PURE__*/React.createElement("p", {
      className: "rv-empty"
    }, "No photo or video reviews for ", PRODUCTS[filter].name, " yet. ", /*#__PURE__*/React.createElement("button", {
      className: "rv-empty-reset",
      onClick: () => pickFilter('ALL')
    }, "Show all products")), wallLimit < media.length && /*#__PURE__*/React.createElement("div", {
      className: "rv-more-row"
    }, /*#__PURE__*/React.createElement("button", {
      className: "rv-more",
      onClick: () => setWallLimit(l => l + 3)
    }, "View more photos")))), /*#__PURE__*/React.createElement("section", {
      className: "gx-section cream",
      "data-screen-label": "Written reviews"
    }, /*#__PURE__*/React.createElement("div", {
      className: "gx-wrap-wide"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-sect-head"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rv-eyebrow"
    }, /*#__PURE__*/React.createElement("span", {
      className: "dot"
    }), "In their words"), /*#__PURE__*/React.createElement("h2", null, "What owners are writing"), /*#__PURE__*/React.createElement("p", null, "Verified, unedited feedback from horse owners across every protocol.")), /*#__PURE__*/React.createElement("div", {
      className: 'rv-list ' + text
    }, shown.map(r => /*#__PURE__*/React.createElement(Card, {
      key: r.id,
      r: r,
      feat: feat
    }))), written.length === 0 && /*#__PURE__*/React.createElement("p", {
      className: "rv-empty"
    }, "No written reviews for ", PRODUCTS[filter].name, " yet. ", /*#__PURE__*/React.createElement("button", {
      className: "rv-empty-reset",
      onClick: () => pickFilter('ALL')
    }, "Show all products")), limit < written.length && /*#__PURE__*/React.createElement("div", {
      className: "rv-more-row"
    }, /*#__PURE__*/React.createElement("button", {
      className: "rv-more",
      onClick: () => setLimit(l => l + 3)
    }, "View more reviews")))), lbIndex >= 0 && /*#__PURE__*/React.createElement(Lightbox, {
      r: media[lbIndex],
      onClose: closeLb,
      onPrev: () => step(-1),
      onNext: () => step(1)
    }));
  }
  function mount() {
    const el = document.getElementById('root');
    if (!el || el.dataset.mounted) return;
    el.dataset.mounted = '1';
    ReactDOM.createRoot(el).render(/*#__PURE__*/React.createElement(App, null));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);else mount();
})();
